import { syncSubscriptionInvoiceToZoho } from "../config/api.subscriptions";

//messages.js
export default {
	subscription_id: "Subscription ID",
	device_id: "Device Id",
	account_id: "Company Id",
	stripe_subscription_id: "Stripe Subscription Id",
	plan_name: "Plan Name",
	amount: "Amount",
	device_seats: "Device Seats",
	period_start: "Period Start",
	term_length: "Term Length",
	period_end: "Period End",
	paid: "Paid",
	status: "Status",
	invoice_id: "Invoice Id",
	notes: "Notes",
	edit_subscription: "Edit Subscription",
	add_subscription: "Add Subscription",
	delete_subscription: "Delete Subscription",
	subscriptions: "Subscriptions",
	delete_subscription_confirm: "This action is not reversible!",
	device_number: "Device #",
	Subscriptions: "Subscriptions",
	expired: "Expired",
	upcoming: "Upcoming",
	days: "Days",
	billed: "Billed",
	mark_as_billed: "Mark as Billed",
	mark_as_paid: "Mark as Paid",
	to: "to",
	select_zoho_invoice: "Select Zoho Invoice",
	invoice_number: "Invoice #",
	plan_duration: "Plan Duration",
	total_count: "Total Count",
	past_due: "Past Due",
	due: "Due",
	no_subscriptions_selected: "No Subscriptions Selected",
	no_subscriptions_found: "No Subscriptions",
	select_all: "Select All",
	deselect_all: "Deselect All",
	months: "Months",
	overdue: "Overdue",
	canceled: "Canceled",
	bill_to: "Bill To",
	bucket: "Bucket",
	old: "Old",
	edit_subscription_renewal: "Edit Subscription Renewal",
	add_subscription_renewal: "Add Subscription Renewal",
	save_selections: "Save Selections",
	confirm_and_create_invoice: "Confirm & Create Invoice",
	expiring: "Expiring",
	status: "Status",
	invoices: "Invoices",
	items: "Items",
	total: "Total",
	synced: "Synced",
	not_synced: "Not Synced",
	void: "Void",
	copy_zoho_invoice: "Copy Zoho Invoice",
	devices: "Devices",
	pending: "Pending",
	device_number: "Device #",
	locked: "Locked",
	invoiced: "Invoiced",
	no_devices_found: "No devices found.",
	view_invoice: "View Invoice",
	sync_to: "Sync to",
	back_to_kanban: "Back to Kanban",
	void_invoice: "Void Invoice",
	this_will_release_items_back_to_pending_remaining: "This will release items back to Pending/Remaining.",
	selected: "Selected",
	of: "of",
	invoice_created: "Invoice Created",
	export_to_csv: "Export to CSV",
};
